import { convertInToCm } from '@pelicargo/utils';

import { trpc, TrpcInputs, TrpcOutputs } from '../../config/trpc';
import { MutateFunction, UseMutateResource } from '../../utils/types';

type CargoInput = TrpcInputs['updateCargo'];
type CargoOutput = TrpcOutputs['updateCargo'];

type MutateCargo = MutateFunction<CargoInput, CargoOutput>;
type UseUpdateCargo = UseMutateResource<MutateCargo>;

const formatCargo = (raw: any): CargoInput => {
  const next: any = { ...raw };
  if (next?.length) next.length = convertInToCm(next.length);
  if (next?.width) next.width = convertInToCm(next.width);
  if (next?.height) next.height = convertInToCm(next.height);

  return next;
};

export const useUpdateCargo = (id: number): UseUpdateCargo => {
  const { mutateAsync, isLoading, error } = trpc.updateCargo.useMutation();

  const mutate: MutateCargo = (args) => mutateAsync({ id, ...formatCargo(args) } as CargoInput);

  return [mutate, isLoading, error?.message];
};
